import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, NavigationEnd, Event as RouterEvent, RouterOutlet, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FooterComponent } from './footer';
import { HeaderComponent } from './header';
import { SidebarComponent } from './sidebar';
import { ThemeCustomizerComponent } from './theme-customizer';
import { GlobalCommandPaletteComponent } from './global-command-palette/global-command-palette.component';
import { NgClass, NgIf } from '@angular/common';
import { AppService } from '@services/app.service';
import { BrandLoaderSvgComponent } from '@shared/brand-loader-svg/brand-loader-svg.component';
import { CampaignNotificationPopupComponent } from '../shared/components/campaign-notification-popup/campaign-notification-popup.component';
import { ImpersonationApprovalPopupComponent } from '../shared/components/impersonation-approval-popup/impersonation-approval-popup.component';
import { ImpersonationBannerComponent } from '../shared/components/impersonation-banner/impersonation-banner.component';
import { AppUpdateService } from '@app/core/services/app-update/app-update.service';
import { AppUpdateBannerComponent } from '../shared/components/app-update-banner/app-update-banner.component';
import { FreePlanUpgradeBannerComponent } from '../shared/components/free-plan-upgrade-banner/free-plan-upgrade-banner.component';
import { TrialEndedModalComponent } from '../shared/components/trial-ended-modal/trial-ended-modal.component';
import { ImportProgressToastComponent } from '../shared/components/import-progress-toast/import-progress-toast.component';

@Component({
    selector: 'app-root',
    templateUrl: './app-layout.html',
    standalone: true,
    imports: [
        NgClass,
        NgIf,
        BrandLoaderSvgComponent,
        ThemeCustomizerComponent,
        SidebarComponent,
        HeaderComponent,
        GlobalCommandPaletteComponent,
        RouterOutlet,
        FooterComponent,
        CampaignNotificationPopupComponent,
        ImpersonationApprovalPopupComponent,
        ImpersonationBannerComponent,
        AppUpdateBannerComponent,
        FreePlanUpgradeBannerComponent,
        TrialEndedModalComponent,
        ImportProgressToastComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppLayout implements OnInit, OnDestroy {
    store: any;
    showTopButton = false;
    currentModule: string = '';
    headerClass = '';

    private readonly appUpdateService = inject(AppUpdateService);

    constructor(public translate: TranslateService, public storeData: Store<any>, private service: AppService, private router: Router, private activatedRoute: ActivatedRoute) {
        this.initStore();
        this.currentModule = this.activatedRoute.snapshot?.url[0]?.path || '';
    }

    ngOnInit() {
        this.initAnimation();
        this.toggleLoader();
        this.appUpdateService.initialize();
        window.addEventListener('scroll', () => {
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                this.showTopButton = true;
            } else {
                this.showTopButton = false;
            }
        });
    }

    ngOnDestroy() {
        this.appUpdateService.ngOnDestroy();
        window.removeEventListener('scroll', () => {});
    }

    initAnimation() {
        this.service.changeAnimation();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.service.changeAnimation();
            }
        });

        const ele: any = document.querySelector('.animation');
        ele.addEventListener('animationend', () => {
            this.service.changeAnimation('remove');
        });
    }

    toggleLoader() {
        this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
        setTimeout(() => {
            this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
        }, 500);
    }

    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    goToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
